import axiosInstance from '../lib/axios';

// Function to fetch users
// export const fetchCustomerJourney = async (industriesType, filteredData) => {
//     const [_key, { industriesType, filteredData }] = queryKey;
//     const response = await axiosInstance.get('/admin/blueprints');
//     // const response = await axiosInstance.get('/admin/blueprints', {
//     //     params: { industriesType ,filteredData  }
//     // });
//     return response.data;
// };
// Function to fetch users
export const fetchCustomerJourney = async ({ queryKey }) => {
    const [_key, { industriesType, filteredData }] = queryKey;
    const response = await axiosInstance.get('/admin/blueprints', {
        params: { industriesType: industriesType, filteredData: filteredData }
    });
    return response.data;
};
export const fetchIndustries = async ({ queryKey }) => {
    const response = await axiosInstance.get('/admin/allIndustries');
    return response.data;
};
export const addCustomerJourney = async (customerJourneyData) => {
    try {
        const response = await axiosInstance.post('/admin/blueprints', customerJourneyData);

        return response.data; // Return the created customer journey
    } catch (error) {
        console.error('Error adding customer journey:', error);
        throw error; // Ensure errors can be handled by the caller
    }
};
export const updateCustomerJourney = async (id, customerJourneyData) => {
    try {
        const response = await axiosInstance.put(`/admin/updateblueprints/${id}`, customerJourneyData);

        return response.data; // Return the created customer journey
    } catch (error) {
        console.error('Error adding customer journey:', error);
        throw error; // Ensure errors can be handled by the caller
    }
};
// Function to delete user
export const deleteCustomerJourney = (id) => axiosInstance.put(`/admin/blueprints/${id}`);
